import { Chip } from '@mui/material'
import {
  Error as ErrorIcon,
  Schedule as ScheduleIcon,
  DoneAll as DoneAllIcon,
  Done as DoneIcon,
} from '@mui/icons-material'
import { Message } from '../../../services/campaignApi'


export const SORT_OPTIONS = [
  { value: 'sent_at', label: 'Sent At' },
  { value: 'delivered_at', label: 'Delivered At' },
  { value: 'read_at', label: 'Read At' },
  { value: 'lead_name', label: 'Lead Name' },
  { value: 'lead_phone', label: 'Phone' },
  { value: 'status', label: 'Status' },
]

export const renderStatusChip = (msg: Message) => {
  if (msg.is_read) {
    return <Chip label="Read" color="info" size="small" />
  }
  if (msg.is_delivered) {
    return <Chip label="Delivered" color="success" size="small" />
  }
  if (msg.is_sent) {
    return <Chip label="Sent" color="warning" size="small" />
  }
  if (msg.is_failed) {
    return <Chip label="Failed" color="error" size="small" />
  }
  return <Chip label="Pending" color="default" size="small" />
}

export const getStatusDisplay = (msg: Message) => {
  if (msg.is_read) {
    return { label: 'Read', icon: <DoneAllIcon fontSize="inherit" />, color: 'info.main' }
  }
  if (msg.is_delivered) {
    return { label: 'Delivered', icon: <DoneAllIcon fontSize="inherit" />, color: 'text.secondary' }
  }
  if (msg.is_sent) {
    return { label: 'Sent', icon: <DoneIcon fontSize="inherit" />, color: 'text.secondary' }
  }
  if (msg.is_failed) {
    return { label: 'Failed', icon: <ErrorIcon fontSize="inherit" sx={{mb:'2px'}} />, color: 'error.main' }
  }
  return { label: 'Pending', icon: <ScheduleIcon fontSize="inherit" sx={{mb:'2px'}} />, color: 'text.disabled' }
}
